import { Topbar } from './Topbar';

interface PageHeaderProps {
  title: string;
  description?: string;
  actions?: React.ReactNode;
  children?: React.ReactNode;
}

export function PageHeader({ title, description, actions, children }: PageHeaderProps): JSX.Element {
  return (
    <>
      <Topbar title={title} actions={actions} description={description} />
      {children ? <div className="mx-auto w-full max-w-[1400px] p-vt-6">{children}</div> : null}
    </>
  );
}
